<script lang="ts">
	import AchievementsWidget from '$pages/achievements/AchievementsWidget.svelte';
	import type { Achievement } from '../../domain/Achievement';
	import { achievementResponseStore } from '../../store/AchievementStore';

	const { data }: { data: { showAchievementsWidget: boolean, achievements: Achievement[], points: number } } = $props();

	$effect.pre(() => {
		if (data.achievements) {
			achievementResponseStore.set({ actualAchievements: data.achievements, pastAchievements: [], comingSoonAchievements: [], batchId: 0, success: true });
		}
	});

</script>

{#if data.showAchievementsWidget && data.achievements.length > 0}
	<AchievementsWidget points={data.points}/>
{/if}
